__turbopack_context__.v({
  "banners": "style-module-scss-module__lMCmzq__banners",
  "img": "style-module-scss-module__lMCmzq__img",
});
